import About from '../About'
import AccountCard from '../AccountCard.js/AccountCard'
import AppTitle from './AppTitle'
import './AppBar.css'

const AppBar = () => {
    return (
        <>
            <div className="app-bar">
                <About />
                <AppTitle />
                <AccountCard />
            </div>
        </>
    )
}

export default AppBar
